import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=664f5295"
import script from "./location.ts?vue&type=script&lang=js&external"
export * from "./location.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports